export default __webpack_public_path__ + "static/Butler-ExtraBold-ec03900c0f703440de61ca478fc92e4e.woff2";